import React from "react";

import {
  UniqueBnDev,
  SessionDistribution,
  UniqueBookings,
  UniqueBought,
} from "../Main/components";

const ContentPerformance = () => {
  return (
    <div className="flex-grow" style={{ width: "75%" }}>
      <div className="my-3 p-3 w-full space-y-5">
        <UniqueBnDev display={"content performance"} />
        <SessionDistribution display={"content performance"} />
        <UniqueBookings />
        <UniqueBought />
      </div>
    </div>
  );
};

export default ContentPerformance;
